<div class="header-left">
  <button class="back-btn" (click)="goBack()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M19 12H5"></path>
      <path d="M12 19l-7-7 7-7"></path>
    </svg>
    Back
  </button>
</div>
<div class="header">
  <div class="page-title">Transaction History</div>
  <app-page-size
    [pageSize]="pageSize"
    [selectId]="'transactions'"
    (pageSizeChanged)="onPageSizeChange($event)"
  ></app-page-size>
</div>
<app-table
  [columns]="tableColumns"
  [data]="transactions"
  [loading]="transactionsLoading"
  [noResultsMessage]="'No transactions found.'"
  [skeletonRows]="5"
>
  <ng-template let-transaction>
    <tr>
      <td>
        {{ transaction.created_at | date: "MMM d, y" }}
      </td>

      <td>
        {{ transaction.invoice_number || "-" }}
      </td>

      <td>
        {{ transaction.currency }}
        {{ transaction.amount }}
      </td>

      <td>
        <span class="status" [ngClass]="getStatusClass(transaction.status)">
          {{ transaction.status | titlecase }}
        </span>
      </td>

      <td>
        @if (transaction.receipt_url) {
          <button
            type="button"
            class="action-btn view-btn"
            (click)="viewReceipt(transaction.receipt_url)"
            title="View Receipt"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <span>View</span>
          </button>
        } @else {
          <span class="empty-cell">-</span>
        }
      </td>

      <td>
        @if (transaction.invoice_pdf) {
          <button
            type="button"
            class="action-btn pdf-btn"
            (click)="
              downloadPdf(transaction.invoice_pdf, transaction.invoice_number)
            "
            title="Download PDF"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3v12"></path>
              <path d="M7 10l5 5 5-5"></path>
              <path d="M5 21h14"></path>
            </svg>
            <span>PDF</span>
          </button>
        } @else {
          <span class="empty-cell">-</span>
        }
      </td>
    </tr>
  </ng-template>
</app-table>

@if (!transactionsLoading && (hasPrevious || hasNext)) {
  <div class="pagination-wrapper">
    <a
      href="javascript:void(0);"
      [class.disabled]="!hasPrevious"
      (click)="onPrevious()"
      title="Previous"
    >
      <app-svg-icon
        [iconName]="'previous.svg'"
        [width]="'15px'"
        [height]="'15px'"
        [style.fill]="'#666'"
      ></app-svg-icon>
    </a>
    <a
      href="javascript:void(0);"
      [class.disabled]="!hasNext"
      (click)="onNext()"
      title="Next"
    >
      <app-svg-icon
        [iconName]="'next.svg'"
        [width]="'15px'"
        [height]="'15px'"
        [style.fill]="'#666'"
      ></app-svg-icon>
    </a>
  </div>
}
